export const ProfileColor = "#00a2ff;";

export function logProfile(
  context: string,
  time: number,
  threshold: number = null,
  color: string = null,
) {
  color = color || ProfileColor;
  const logColor = `color: ${color};`;
  const timeColor = threshold && time > threshold ? "color: red;" : logColor;

  console.log(
    `%c[Profile] ${context} took %c${time.toFixed(0)} ms`,
    logColor,
    timeColor,
  );
}

export function wrapFunction(
  originalFunction: Function,
  { context = null, threshold = null, color = ProfileColor } = {},
) {
  const detail = context
    ? `${context}.${originalFunction.name}`
    : originalFunction.name;
  // Wrap the original function so we can time it.
  // NOTE: Cannot use an arrow function here - arrow functions lose "this" context
  const wrappedFunction = function (...args: any[]) {
    // Time the wrapped function
    const t0 = performance.now();
    const result = originalFunction.apply(this, args);
    const t1 = performance.now();

    // Log the timing information
    const delta = t1 - t0;
    //If disableSpecificProfiling has not been set in localStorage then log profiling
    if (!localStorage.getItem("disableSpecificProfiling")) {
      logProfile(detail, delta, threshold, color);
    }
    return result;
  };
  return wrappedFunction;
}
